import { useEffect, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAttachments, getAttachmentsStatus } from '../selectors';
import { IsDemo } from 'core/context';
import { loadAttachments as loadAttachmentsAction } from '../actions';
import { STATUS as API_STATUS } from '../constants';

// Adheres to a proposed Api hook type: APIType { data, isLoading, error }
// TODO: replace with useSWR, use everywhere, delete all the redux behind this
export const useAttachments = (
  classId,
  attachmentType,
  objectId,
  includeTeacherAttachments
) => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { isDemo } = useContext(IsDemo);

  // must be declared before the useEffect below, or the effect won't run
  // time the attachmentStatus is updated.
  const attachmentStatus = useSelector((state) =>
    getAttachmentsStatus(state, classId, attachmentType, objectId)
  );

  useEffect(() => {
    if (attachmentStatus === API_STATUS.UNINITIALIZED) {
      dispatch(
        loadAttachmentsAction.signal(classId, attachmentType, objectId, isDemo)
      );
    }

    if (
      ![API_STATUS.LOADING, API_STATUS.RELOADING].includes(attachmentStatus)
    ) {
      setIsLoading(false);
    }
  }, [dispatch, classId, attachmentType, objectId, attachmentStatus, isDemo]);

  const attachments = useSelector((state) =>
    getAttachments(
      state,
      classId,
      attachmentType,
      objectId,
      includeTeacherAttachments
    )
  );

  const error =
    attachmentStatus === API_STATUS.ERROR ? 'Error loading attachments' : null;

  if (error) {
    console.warn('There was an error loading attachments', error);
  }

  return {
    data: attachments,
    isLoading, // FIX: isLoading is returning false before loading attachments
    error,
  };
};
